import script from "./MessageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageTable.vue?vue&type=script&setup=true&lang=js"

import "./MessageTable.vue?vue&type=style&index=0&id=683cccd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683cccd0"]])

export default __exports__